// LLM Store Module
import { createBaseModule } from './base'
import { llmApi } from '@/services/api'

// Custom state for LLM
const customState = {
  models: [],
  modelOptions: {}
}

// Custom getters for LLM
const customGetters = {
  // Get all models
  allModels: state => state.models,

  // Get specific model options
  getModelOptions: state => provider => state.modelOptions[provider] || []
}

// Custom actions for LLM
const customActions = {
  async fetchModelOptions({ commit }, provider) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')

      const options = await llmApi.getModelOptions(provider)
      commit('SET_MODEL_OPTIONS', { provider, options })

      return options
    } catch (error) {
      commit('SET_ERROR', error.message || `Failed to fetch options for ${provider}`)
      throw error
    }
  }
}

// Custom mutations for LLM
const customMutations = {
  SET_MODEL_OPTIONS(state, { provider, options }) {
    state.modelOptions = {
      ...state.modelOptions,
      [provider]: options
    }
  }
}

// Create and export the LLM module
export default createBaseModule('llm', llmApi, {
  customState,
  customGetters,
  customActions,
  customMutations
})

